<template>
    
    <b-modal ref="upgradesModal" id="upgrades-modal" title="Upgrade Account" hide-footer scrollable>
        <div v-if="clientInfo.clientAccount != 'PRO'"> 

            <div class="container" style="padding-top: 100px">
                <h3 class="text-center main-sub-title">go pro</h3>
                <h2 class="text-center main-title">Select your plan of choice and start going PRO</h2>
                
                
                <b-card-group deck>
                    <b-card
                    header="1 SITE"
                    header-tag="header"
                    footer="Card Footer"
                    footer-tag="footer"
                    title="$25"
                    >

                        All <span class="bold-font">PRO</span> elements and features for
                        <!--div class="sites-amount"--><span class="bold-font">1 site</span><!--/div-->
                        <div class="accept_terms-box-wrap">
                        <b-form-checkbox
                        class="accept_terms-box"
                        v-model='terms'
                        >
                        I accept the terms of use
                        </b-form-checkbox>
                        <span class="read_terms" v-b-modal="'tos-modal'">- read terms</span>
                        </div>

                        <div slot="footer">
                            <b-button :disabled="isDisabled" block variant="outline-primary" :href="'https://www.appjustable.com/weebly/app_in_process/buttons/upgrade.php?jwt-token='+siteToken+'&type=1'" target="_blank">Buy Now</b-button>
                        </div>
                    </b-card>

                    <b-card
                    header="5 SITES"
                    header-tag="header"
                    footer="Card Footer"
                    footer-tag="footer"
                    title="$100"
                    >
                        <div class="savings-info"><span>Save<br>20%</span></div>
                        All <span class="bold-font">PRO</span> elements and features for
                        <!--div class="sites-amount"--><span class="bold-font">5 sites</span><!--/div-->
                        <div class="accept_terms-box-wrap">
                        <b-form-checkbox
                        class="accept_terms-box"
                        v-model='terms'
                        >
                        I accept the terms of use
                        </b-form-checkbox>
                        <span class="read_terms" v-b-modal="'tos-modal'"> - read terms</span>
                        </div>

                        <div slot="footer">
                            <b-button :disabled="isDisabled" block variant="outline-primary" :href="'https://www.appjustable.com/weebly/app_in_process/buttons/upgrade.php?jwt-token='+siteToken+'&type=2'" target="_blank">Buy Now</b-button>
                        </div>
                    </b-card>

                    <b-card
                    header="10 SITES"
                    header-tag="header"
                    footer="Card Footer"
                    footer-tag="footer"
                    title="$150"
                    class="last-card"
                    >

                        <div class="savings-info"><span>Save<br>40%</span></div>

                        All <span class="bold-font">PRO</span> elements and features for
                        <!--div class="sites-amount"--><span class="bold-font">10 sites</span><!--/div-->

                        <div class="accept_terms-box-wrap">
                        <b-form-checkbox
                        class="accept_terms-box"
                        v-model='terms'
                        >
                        I accept the terms of use
                        </b-form-checkbox>
                        <span class="read_terms" v-b-modal="'tos-modal'">- read terms</span>
                        </div>

                        <div slot="footer">
                            <b-button :disabled='isDisabled' block variant="outline-primary" :href="'https://www.appjustable.com/weebly/app_in_process/buttons/upgrade.php?jwt-token='+siteToken+'&type=3'" target="_blank">Buy Now</b-button>
                        </div>
                    </b-card>
                </b-card-group>
            </div>
        </div>

        <div v-if="clientInfo.clientAccount == 'PRO'">
            <p>You are already using a PRO version of the app on this site</p>
        </div>
    </b-modal>

</template>

<script>
export default {

    name: 'UpgradeAccount',

    data() {
        return {
            siteToken: this.$store.state.jwtToken,
            terms: false
        }
    },
    methods: {
        UpgradeAccount(type) {

            
        }
    },

    computed: {
        clientInfo() {
            return this.$store.state.clientInfo
        },

        isDisabled: function(){
            return !this.terms;
        }

        
    }

}
</script>

<style lang="less">
@import '../less/colors.less';

#upgrades-modal {
    .accept_terms-box-wrap {
        padding: 10px 0 0;
        margin: 45px 0 10px;
    }
    .accept_terms-box {
        display: inline-block;
    }
    .modal-dialog {
            max-width: none!important;
            width: 100%!important;
            max-height: 100%;
            margin: 0 auto;
            min-height: 100%;
            height: 100%;
        }

        .modal-content {
            max-height: 100%;
            border: 0;
            border-radius: 0;
            height: 100%;
        }

        .modal-header {
            border-radius: 0;
            z-index: 10;
            -webkit-box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
            box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
        
    }
    p {
        text-align: center;
        font-size: 17px;
        margin: 30px auto 45px;
    }
    .card-deck {
        // text-align: center;
        margin: 0;
        margin-bottom: 45px;

        .card-body {
            padding-bottom: 0;
        }

        .card {
            margin: 0;
            border: 0;
            border-radius: 0;
            border-left: 1px solid @border_grey_medium;
            border-top: 1px solid @border_grey_medium;
            border-bottom: 1px solid @border_grey_medium;
            padding-top: 15px;
            padding-bottom: 15px;
            text-align: center;
        }

        .last-card {
            border-right: 1px solid @border_grey_medium;
        }

        .card-header {
            letter-spacing: 1px;
            background: @shark_teeth;
            background: #fff;
            border: 0;
            font-weight: 700;
        }

        .card-title {
            margin-bottom: 30px;
            color: @action_blue;
            font-size: 45px;
            font-family: 'Roboto', sans-serif;
            font-weight: 100;
        }

        .card-footer {
            background: #fff;
            border: 0;
            padding-top: 0;

            a {
                font-weight: 700;
                text-transform: uppercase;
                font-size: 12px;
                height: 40px;
                line-height: 40px;
                padding: 0;
            }
        }
    }

    .sites-amount {
        font-size: 20px;
        font-weight: 700;
    }
    .bold-font {
        font-weight: 700;
        border-bottom: 1px solid @action_blue;
    }
}

.savings-info {
    position: absolute;
    top: 0;
    right: 10px;
    transform: translateY(-50%);
    background: #fff ;
    border-radius: 100%;
    color: @action_orange;
    border: 1px solid @action_orange;
    font-weight: 700;
    width: 56px;
    height: 56px;

    span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        font-size: 12px;
    }
}
.read_terms {
    color: @action_blue;
    font-size: 12px;
    font-style: italic;
    cursor: pointer;
    &:hover {
        opacity: .8;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/UpgradeAccount.vue